module.exports = {
  semi: false,
  singleQuote: true,
  quoteProps: 'consistent',
  trailingComma: 'all',
  arrowParens: 'always',
  printWidth: 100,
}
